@use 'vars';
@use 'mixins';

$INPUT_CONTAINER_MAX_WIDTH: 400px;
$INPUT_MAX_HEIGHT: 250px;
$INPUT_MAX_HEIGHT_SMALL: 150px;
$MENU_CONTAINER_COMFORTABLE_MAX_HEIGHT: 60vh;
$MENU_CONTAINER_COMFORTABLE_MIN_HEIGHT: 100px;

.iq-menu-container {
  display: flex;
  flex-direction: column;
  gap: vars.$gap-small;
  max-width: 100%;
  min-width: 100%;

  &--comfortable {
    max-height: $MENU_CONTAINER_COMFORTABLE_MAX_HEIGHT;
    min-height: $MENU_CONTAINER_COMFORTABLE_MIN_HEIGHT;

    .iq-menu-container {
      &__content {
        overflow-y: auto;
        flex: 1;
        min-height: $MENU_CONTAINER_COMFORTABLE_MIN_HEIGHT;
      }
    }
  }

  &__content {
    position: relative;
    align-items: flex-start;
    height: fit-content;
    overflow: hidden;

    &__actions {
      position: relative;
      min-width: 100%;
      left: 0;
      transition: vars.$iq-menu-transition;
      min-height: 30px;

      &--hidden {
        position: absolute;
        inset: 0;
        transform: translateX(-100%);
        opacity: 0;
        pointer-events: none;
      }

      &--stand-alone {
        padding: vars.$padding-large vars.$padding-large 50px;

        &__input-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          align-self: stretch;
          max-width: $INPUT_CONTAINER_MAX_WIDTH;
          box-sizing: border-box;
          padding: vars.$padding-large vars.$padding-large vars.$padding-large vars.$padding-large;
          gap: vars.$gap-xlarge;
          border-radius: vars.$border-radius-xxlarge vars.$border-radius-xxlarge 0 vars.$border-radius-xxlarge;
          background-color: vars.$white;
          box-shadow:
            0 0 0 0.8px rgba(0, 0, 0, 0.12),
            0 6px 24px 0 rgba(118, 69, 221, 0.15);
        }

        &__input {
          @include mixins.scrollable-container;

          max-height: $INPUT_MAX_HEIGHT;
          width: 100%;

          @media screen and (max-width: vars.$softphone-max-width) {
            max-height: $INPUT_MAX_HEIGHT_SMALL;
          }
        }
      }
    }

    &__evaluate {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      transform: translateX(100%);
      opacity: 0;
      pointer-events: none;
      transition:
        transform 200ms ease,
        opacity 180ms ease;
      overflow: hidden;

      &--visible {
        position: relative;
        transform: translateX(0);
        opacity: 1;
        pointer-events: auto;
        overflow: auto;
        transition: vars.$iq-menu-transition;
      }
    }
  }
}
